export class GetUserModel {
    limit: number = 0;
    page: number = 0;
    sorttype: number = 0;
    sortcol: string = "";
    usernamesearch: string = "";
    companynamesearch: string = "";
    phonenumbersearch: string = "";
    provincesearch: string = "";
    countrysearch:  string = "";
    startDate?: Date;
    endDate?: Date;
    userInactiveStatus: number;
    referralCode?: string[];
}
export class UserListIndexModel {
    data: Array<UserlistModel> = new Array<UserlistModel>();
    count: number = 0;
}
export class UserlistModel {
    userSurrKey: number = 0;
    userName: string = "";
    userSurName: string = "";
    userEmail: string = "";
    userPhone: string = "";
    obsolete: boolean;
    userCountry: string = "";
    userLanguage: string = "";
    userAddress: string = "";
    userAmphur: string = "";
    userAvatar: string;
    employeeSurrKey: number;
    poCount: number;
    createdDateUser: string = "";
    createdDateEmployee: string = "";
    companySurrKey: number = 0;
    companyName: string = "";
    companyProvince: string = "";
    companyTypesName: string = "";
    roles: string = "";
    comment: string = "";
    emailConfirmed: boolean;
    lockoutEnabled: boolean;
    accessFailedCount: number;
    isRegister: boolean = false;
    activateDate: string = "";
    userInactiveStatus: number;
}
